import { useRef } from 'react';
import { useCurrentStateAndParams } from '@uirouter/react';

import { isEnvironmentUrl } from '@/portainer/services/endpointProvider';
import { useChangeConfirmationPolicy } from '@/react/portainer/environments/queries/useChangeConfirmationPolicy';
import { linkifyMessage } from '@/react/components/modals/linkifyMessage';

const FALLBACK_COLOR = '#cccccc';

export function EnvironmentBanner() {
  const { params } = useCurrentStateAndParams();
  const environmentId = isEnvironmentUrl(params.endpointId)
    ? Number(params.endpointId)
    : undefined;

  const policy = useChangeConfirmationPolicy(environmentId);
  const bannerRef = useRef<HTMLDivElement>(null);

  if (!policy?.HighlightEnabled?.value) {
    return null;
  }

  const color = sanitizeColor(policy.HighlightColor?.value ?? FALLBACK_COLOR);
  const message = policy.BannerMessage?.value ?? '';
  const isTruncated = isBannerTruncated();

  return (
    <>
      <style>{`
        .page-content {
          padding: 0.5rem;
          background: ${color};
          height: ${message ? 'calc(100% - 1.75rem)' : '100%'};
          }
          `}</style>
      {message && (
        // banner height is 1.75rem
        <div
          ref={bannerRef}
          title={isTruncated ? message : undefined}
          className="w-full pt-2 px-2 text-sm text-ellipsis overflow-hidden whitespace-nowrap text-center"
          style={{
            backgroundColor: color,
            color: `oklch(from ${color} round(1.21 - L) 0 0)`,
          }}
        >
          {linkifyMessage(message, {
            linkClassName: '!text-inherit underline',
          })}
        </div>
      )}
    </>
  );

  function isBannerTruncated() {
    const el = bannerRef.current;
    return el && el.scrollWidth > el.clientWidth;
  }
}

function sanitizeColor(value: string): string {
  if (typeof CSS === 'undefined' || typeof CSS.supports !== 'function') {
    return value;
  }
  return CSS.supports('color', value) ? value : FALLBACK_COLOR;
}
